import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Message } from './message'
import { MessageSerializer } from './message.serializer'
import { messageSelectors } from './message.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { map } from 'rxjs/operators'
import { SerieProposal } from '../booking/serie-proposal/serie-proposal'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'

@UntilDestroy()
@Injectable()
export class MessageService extends ResourceService<Message> {
  constructor(
    private http: HttpClient,
    private messageSerializer: MessageSerializer,
    private store: Store<AppState>
  ) {
    super(http, `${environment.backendApiUrl}/messages`, messageSerializer)
  }

  public hasNewMessage(serieProposal: SerieProposal): boolean {
    let hasUnreadMessage = false

    this.store
      .select(messageSelectors.selectEntities)
      .pipe(
        untilDestroyed(this),
        map((messageEntities) => {
          return serieProposal.messages?.some((messageId) => {
            const message = messageEntities[messageId]
            return (
              message &&
              !message.dateRead &&
              message.senderPersonId == serieProposal.customerPersonId
            )
          })
        })
      )
      .subscribe((hasUnread) => {
        hasUnreadMessage = hasUnread
      })

    return hasUnreadMessage
  }
}
